import React from 'react';
// components
import BaseToggle from 'src/shared/components/inputs/BaseToggle';

const FixedValueToggle = ({ name, value, setFieldValue, readOnly }) => {
  const checked = value?.toString()?.toLowerCase() === 'true' ? true : false;

  return (
    <BaseToggle
      label=''
      name={name}
      checked={checked}
      onChange={({ value }) => setFieldValue(value)}
      onText='Yes'
      offText='No'
      readOnly={readOnly}
    />
  );
};

export default FixedValueToggle;
